const { LANGUAGES } = require('utils/LanguageLocale');


const localeSelector = () => {
    const locale = (Sephora.renderQueryParams && Sephora.renderQueryParams.language) || LANGUAGES.EN;

    return locale.toUpperCase();
};

module.exports = { localeSelector };
